import getAuth, { getIdTokenResult } from '@/utils/auth';
import getLocallySignedToken from '@/utils/getLocallySignedToken';

export default async function getToken(forceRefresh = false) {
  const auth = getAuth();
  let token: string | null = null;

  const tokenResult = auth.currentUser
    ? await getIdTokenResult(auth.currentUser, forceRefresh)
    : null;

  token = tokenResult?.claims['https://hasura.io/jwt/claims']
    ? tokenResult.token
    : null;

  if (token && process.env.EXPO_PUBLIC_ENV_NAME === 'dev') {
    token = getLocallySignedToken(
      token,
      process.env.EXPO_PUBLIC_FIREBASE_AUTH_EMULATOR_TOKEN ||
        '54DD4B05F7D72761726425EBB49409C934CCE6E5A62E3CBE523203E6FD08301B',
    );
  }

  return token;
}
